import React from 'react';
import { Input, Button } from 'reactstrap';
import { Trans } from 'lingui-react';

import './commentInput.css';

export const CommentInput = (props) => {
    return (
        <div className={props.display ? "comment-input-container" : 'hide-element'}>
            <Input value={props.commentContent} onChange={props.onChangeTextarea} id={props.questionId} placeholder={props.placeholder} className={'comment-input'} type="textarea" name="text" >
            </Input>
            <Button onClick={props.handleSave} className="button-comment button-save"><Trans id="Save"/></Button>
            <Button onClick={props.handleClickCancel} className="button-comment button-cancel"><Trans id="Cancel"/></Button>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/screens/Question/components/QuestionItem/CommentInput/CommentInput.js